import React from 'react';

class Error extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        var dismissable = true;
        if(this.props.dismissable === false){
            dismissable = false;
        }
        return(
            <div className="overlay">
                <div className="window error-message">
                    <div className="d-flex mb-3">
                        <div className="exclamation mr-3">誤</div>
                        <div className="flex-grow-1" dangerouslySetInnerHTML={{ __html: this.props.text }} />
                    </div> 
                    {dismissable && (
                        <React.Fragment>
                            <div className="text-center">
                                <button type="button" className="btn btn-secondary" onClick={this.props.onDismiss}>
                                    Понятно
                                </button>
                            </div>
                            <div className="close-btn" onClick={this.props.onDismiss}>
                                <span className="fa fa-times"></span>
                            </div>
                        </React.Fragment>
                    )}                    
                </div>
            </div>    
        )
    }
}

export default Error; 